<template>
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px" size="mini">
      <el-form-item label="单位名称" prop="unitName">
        <el-input v-model="queryParams.unitName" placeholder="请输入单位名称" clearable style="width: 200px" @keyup.enter.native="handleSearch" />
      </el-form-item>
      <el-form-item label="登记日期">
        <el-date-picker v-model="dateRange" style="width: 220px" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini"
                        @change="handleSearch"></el-date-picker>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" placeholder="请选择状态" clearable style="width: 130px" @change="handleSearch">
          <el-option label="已确认" value="1" />
          <el-option label="未确认" value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <!-- 使用自定义工具栏按钮组件替换搜索和重置按钮 -->
        <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleSearch" @handleReset="handleReset" />
      </el-form-item>
    </el-form>

    <!-- 第一个数据表格：预委托信息 -->
    <el-table v-loading="loading" :data="entrustmentList" @selection-change="handleSelectionChange" @row-click="handleRowClick" border>
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="登记日期" align="center" prop="registerDate" width="100" />
      <el-table-column label="电梯识别码" align="center" prop="elevatorCode" width="120" />
      <!-- 委托编号列 -->
      <el-table-column label="委托编号" align="center" prop="entrustNum" width="180" />
      <el-table-column label="单位名称" align="center" prop="unitName" :show-overflow-tooltip="true" />
      <el-table-column label="合作方业务联系人" align="center" prop="businessContact" width="130" />
      <el-table-column label="现场联系人" align="center" prop="siteContactPerson" width="100" />
      <el-table-column label="现场联系方式" align="center" prop="siteContactPhone" width="120" />
      <el-table-column label="小区名称" align="center" prop="projectName" :show-overflow-tooltip="true" />
      <!-- <el-table-column label="折扣" align="center" prop="discount" width="80" /> -->
      <el-table-column label="年检月份" align="center" prop="inspectionMonth" width="90" />
      <el-table-column label="签订名称" align="center" prop="signCompany" :show-overflow-tooltip="true" />
      <el-table-column label="使用单位统一信用代码" align="center" prop="creditCode" :show-overflow-tooltip="true" />
      <el-table-column label="使用单位地址" align="center" prop="unitAddress" :show-overflow-tooltip="true" />
      <el-table-column label="维保单位" align="center" prop="maintenanceUnit" :show-overflow-tooltip="true" />
      <el-table-column label="状态" align="center" prop="status" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === '1'">已确认</el-tag>
          <el-tag type="warning" v-else>未确认</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" width="150">
        <template slot-scope="scope">
          <!-- 使用自定义行按钮组件替换修改和删除按钮 -->
          <PermissionMethodRow :url="url" :id="'rowtoolbar'" @handleEdit="handleUpdate(scope.row)" @handleDelete="handleDelete(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" />

    <!-- 第二个数据表格：设备详情（监管下载结果） -->
    <div v-if="showEquipmentTable" class="equipment-table-container">
      <div class="equipment-table-title">
        <span>监管详情列表</span>
        <!-- 使用自定义工具栏按钮组件替换关闭按钮 -->
        <!-- <PermissionMethodToolbar :url="url + '/equipment-close'" :id="'equipment-close-toolbar'" @handleClose="showEquipmentTable = false" /> -->
      </div>
      <el-table v-loading="equipmentLoading" :data="equipmentList" border size="mini" height="400" style="margin-top: 10px">
        <el-table-column label="识别码" align="center" prop="code" width="120" />
        <el-table-column label="设备注册代码" align="center" prop="registerCode" width="130" />
        <el-table-column label="设备代码" align="center" prop="equipmentCode" width="120" />
        <el-table-column label="设备种类" align="center" prop="equipmentType" width="100" />
        <el-table-column label="设备类别" align="center" prop="equipmentCategory" width="100" />
        <el-table-column label="设备品种" align="center" prop="equipmentVariety" width="100" />
        <el-table-column label="设备名称" align="center" prop="equipmentName" width="120" />
        <el-table-column label="使用单位" align="center" prop="useUnit" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="单位内编号" align="center" prop="unitInternalCode" width="120" />
        <el-table-column label="设备使用地点" align="center" prop="useLocation" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="设备所在省" align="center" prop="province" width="100" />
        <el-table-column label="设备所在市" align="center" prop="city" width="100" />
        <el-table-column label="设备所在县" align="center" prop="county" width="100" />
        <el-table-column label="使用证编号" align="center" prop="useCertificateNo" width="120" />
        <el-table-column label="维保电话" align="center" prop="maintenancePhone" width="120" />
        <el-table-column label="救援电话" align="center" prop="rescuePhone" width="120" />
        <el-table-column label="安管人员" align="center" prop="safetyManager" width="100" />
        <el-table-column label="安管人员电话" align="center" prop="safetyManagerPhone" width="120" />
        <el-table-column label="制造单位名称" align="center" prop="manufacturerName" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="设备型号" align="center" prop="equipmentModel" width="120" />
        <el-table-column label="产品编号" align="center" prop="productNumber" width="120" />
        <el-table-column label="制造日期" align="center" prop="manufactureDate" width="100" />
        <el-table-column label="最近监检日期" align="center" prop="lastInspectionDate" width="120" />
        <el-table-column label="最近定检机构" align="center" prop="lastInspectionOrg" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="A1-1层数" align="center" prop="floorCount" width="100" />
        <el-table-column label="A1-2站数" align="center" prop="stationCount" width="100" />
        <el-table-column label="门数" align="center" prop="doorCount" width="80" />
        <el-table-column label="A2额定载荷" align="center" prop="ratedLoad" width="100" />
        <el-table-column label="A3额定速度" align="center" prop="ratedSpeed" width="100" />
        <el-table-column label="A4控制方式" align="center" prop="controlMode" width="120" />
      </el-table>
    </div>

    <!-- 新增/修改预委托信息弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="entrustmentFormVisible" width="900px" append-to-body destroy-on-close>
      <el-form ref="entrustmentForm" :model="entrustmentForm" :rules="rules" label-width="140px" size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="登记日期" prop="registerDate">
              <el-date-picker v-model="entrustmentForm.registerDate" type="date" placeholder="选择登记日期" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电梯识别码" prop="elevatorCode">
              <el-input v-model="entrustmentForm.elevatorCode" placeholder="请输入电梯识别码" :disabled="dialogType === 'edit'" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位名称" prop="unitName">
              <div class="input-with-search">
                <el-input v-model="entrustmentForm.unitName" placeholder="请选择单位名称" readonly />
                <!-- 使用自定义工具栏按钮组件替换搜索按钮 -->
                <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="openCustomerSelectDialog" />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合作方业务联系人" prop="businessContact">
              <el-input v-model="entrustmentForm.businessContact" placeholder="请输入合作方业务联系人" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="现场联系人" prop="siteContactPerson">
              <el-input v-model="entrustmentForm.siteContactPerson" placeholder="请输入现场联系人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="现场联系方式" prop="siteContactPhone">
              <el-input v-model="entrustmentForm.siteContactPhone" placeholder="请输入现场联系方式" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="小区名称" prop="projectName">
              <el-input v-model="entrustmentForm.projectName" placeholder="请输入项目名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年检月份" prop="inspectionMonth">
              <el-select v-model="entrustmentForm.inspectionMonth" placeholder="请选择年检月份" style="width: 100%">
                <el-option label="1月" value="1月" />
                <el-option label="2月" value="2月" />
                <el-option label="3月" value="3月" />
                <el-option label="4月" value="4月" />
                <el-option label="5月" value="5月" />
                <el-option label="6月" value="6月" />
                <el-option label="7月" value="7月" />
                <el-option label="8月" value="8月" />
                <el-option label="9月" value="9月" />
                <el-option label="10月" value="10月" />
                <el-option label="11月" value="11月" />
                <el-option label="12月" value="12月" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="签订名称" prop="signCompany">
              <el-select v-model="entrustmentForm.signCompany" placeholder="请选择签订名称" style="width: 100%">
                <el-option label="晨宇总公司" value="晨宇总公司" />
                <el-option label="泉州分公司" value="泉州分公司" />
                <el-option label="漳州分公司" value="漳州分公司" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用代码" prop="creditCode">
              <el-input v-model="entrustmentForm.creditCode" placeholder="请输入使用单位统一信用代码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="使用单位地址" prop="unitAddress">
              <el-input v-model="entrustmentForm.unitAddress" placeholder="请输入使用单位地址" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="维保单位" prop="maintenanceUnit">
              <el-input v-model="entrustmentForm.maintenanceUnit" placeholder="请输入维保单位" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="entrustmentForm.status">
                <el-radio label="1">已确认</el-radio>
                <el-radio label="0">未确认</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="entrustmentFormVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitEntrustmentForm" size="mini">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 客户选择弹窗 -->
    <el-dialog title="选择客户" :visible.sync="customerSelectVisible" width="800px" append-to-body destroy-on-close>
      <!-- 客户搜索条件 -->
      <el-form :model="customerQueryParams" ref="customerQueryForm" :inline="true" size="mini">
        <el-form-item label="客户名称" prop="customerName">
          <el-input v-model="customerQueryParams.customerName" placeholder="请输入客户名称" clearable style="width: 200px" />
        </el-form-item>
        <el-form-item label="使用单位" prop="usageUnit">
          <el-input v-model="customerQueryParams.usageUnit" placeholder="请输入使用单位" clearable style="width: 200px" />
        </el-form-item>
        <el-form-item label="小区名称" prop="projectName">
          <el-input v-model="customerQueryParams.projectName" placeholder="请输入项目名称" clearable style="width: 200px" />
        </el-form-item>
        <el-form-item>
          <!-- 使用自定义工具栏按钮组件替换客户搜索中的按钮 -->
          <!-- <PermissionMethodToolbar :url="url + '/customer-search'" :id="'customer-search-toolbar'" @handleSearch="searchCustomers" @handleReset="resetCustomerQuery" /> -->
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchCustomers">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetCustomerQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 客户列表 -->
      <el-table v-loading="customerLoading" :data="customerList" @row-click="handleCustomerRowClick" @selection-change="handleCustomerSelectionChange" border size="mini" height="350"
                ref="customerTable">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="客户编号" align="center" prop="customerCode" width="100" />
        <el-table-column label="客户名称" align="center" prop="customerName" :show-overflow-tooltip="true" />
        <el-table-column label="使用单位" align="center" prop="usageUnit" :show-overflow-tooltip="true" />
        <el-table-column label="小区名称" align="center" prop="projectName" :show-overflow-tooltip="true" />
        <el-table-column label="联系人" align="center" prop="contactPerson" width="100" />
        <el-table-column label="联系电话" align="center" prop="contactPhone" width="120" />
      </el-table>

      <!-- 客户选择分页 -->
      <pagination v-show="customerTotal > 0" :total="customerTotal" :page.sync="customerQueryParams.pageNum" :limit.sync="customerQueryParams.pageSize" @pagination="getCustomerList"
                  class="customer-pagination" />

      <div slot="footer" class="dialog-footer">
        <el-button @click="customerSelectVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="confirmSelectCustomer" size="mini" :disabled="!selectedCustomer">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'PreEntrustment',
  props: {
    // 添加props以接收URL参数
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 遮罩层
      loading: false,
      equipmentLoading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 15,

      // 按钮组件URL配置 - 直接使用传入的url参数
      // 搜索区域按钮
      // 主工具栏按钮
      // 行操作按钮
      // 客户搜索按钮
      // 设备表格关闭按钮
      // 单位名称搜索按钮

      // 预委托表格数据
      entrustmentList: [
        {
          id: 1,
          registerDate: '2023-05-10',
          elevatorCode: 'DT20230001',
          unitName: '福建省建筑工程有限公司',
          businessContact: '张经理',
          siteContactPerson: '李工',
          siteContactPhone: '13812345678',
          projectName: '福建省政府办公楼',
          // discount: '95%',
          inspectionMonth: '3月',
          signCompany: '晨宇总公司',
          creditCode: '91350000XXXXXXXXXX',
          unitAddress: '福建省福州市鼓楼区省府路1号',
          maintenanceUnit: '福建电梯维保有限公司',
          status: '1'
        },
        {
          id: 2,
          registerDate: '2023-05-15',
          elevatorCode: 'DT20230002',
          unitName: '厦门市商业中心',
          businessContact: '王经理',
          siteContactPerson: '赵工',
          siteContactPhone: '13987654321',
          projectName: '厦门市中心商业广场',
          // discount: '90%',
          inspectionMonth: '6月',
          signCompany: '泉州分公司',
          creditCode: '91350200XXXXXXXXXX',
          unitAddress: '福建省厦门市思明区中山路88号',
          maintenanceUnit: '厦门电梯维保服务中心',
          status: '0'
        },
        {
          id: 3,
          registerDate: '2023-06-01',
          elevatorCode: 'DT20230003',
          unitName: '漳州市医院',
          businessContact: '刘主任',
          siteContactPerson: '陈工',
          siteContactPhone: '13765432109',
          projectName: '漳州市中心医院新院区',
          // discount: '92%',
          inspectionMonth: '9月',
          signCompany: '漳州分公司',
          creditCode: '91350600XXXXXXXXXX',
          unitAddress: '福建省漳州市芗城区胜利路120号',
          maintenanceUnit: '漳州电梯工程有限公司',
          status: '1'
        },
        {
          id: 4,
          registerDate: '2023-06-10',
          elevatorCode: 'DT20230004',
          unitName: '泉州市商场',
          businessContact: '吴经理',
          siteContactPerson: '郑工',
          siteContactPhone: '13678901234',
          projectName: '泉州市购物中心',
          // discount: '88%',
          inspectionMonth: '7月',
          signCompany: '泉州分公司',
          creditCode: '91350500XXXXXXXXXX',
          unitAddress: '福建省泉州市丰泽区东海大街256号',
          maintenanceUnit: '泉州电梯维修服务公司',
          status: '0'
        },
        {
          id: 5,
          registerDate: '2023-06-20',
          elevatorCode: 'DT20230005',
          unitName: '福州市学校',
          businessContact: '黄校长',
          siteContactPerson: '孙工',
          siteContactPhone: '13567890123',
          projectName: '福州市第一中学新校区',
          // discount: '95%',
          inspectionMonth: '4月',
          signCompany: '晨宇总公司',
          creditCode: '91350100XXXXXXXXXX',
          unitAddress: '福建省福州市台江区茶亭街道学府路18号',
          maintenanceUnit: '福州电梯安装维保公司',
          status: '1'
        }
      ],
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        unitName: undefined,
        status: undefined
      },
      // 是否显示设备表格
      showEquipmentTable: false,
      // 设备表格数据
      equipmentList: [
        {
          id: 1,
          code: 'DT20230002',
          registerCode: 'RG20230001',
          equipmentCode: 'EQ20230001',
          equipmentType: '电梯',
          equipmentCategory: '乘客电梯',
          equipmentVariety: '曳引式',
          equipmentName: '乘客电梯',
          useUnit: '厦门市商业中心',
          unitInternalCode: 'XM-DT-001',
          useLocation: '福建省厦门市思明区中山路88号A座',
          province: '福建省',
          city: '厦门市',
          county: '思明区',
          useCertificateNo: 'UC20230001',
          maintenancePhone: '0592-12345678',
          rescuePhone: '0592-87654321',
          safetyManager: '林安全',
          safetyManagerPhone: '13800138000',
          manufacturerName: '奥的斯电梯(中国)有限公司',
          equipmentModel: 'OT-P20',
          productNumber: 'PN20230001',
          manufactureDate: '2022-12-01',
          lastInspectionDate: '2023-04-15',
          lastInspectionOrg: '福建省特种设备检验研究院',
          floorCount: '15',
          stationCount: '15',
          doorCount: '15',
          ratedLoad: '1000kg',
          ratedSpeed: '2.0m/s',
          controlMode: '微机控制'
        },
        {
          id: 2,
          code: 'DT20230004',
          registerCode: 'RG20230002',
          equipmentCode: 'EQ20230002',
          equipmentType: '电梯',
          equipmentCategory: '乘客电梯',
          equipmentVariety: '曳引式',
          equipmentName: '乘客电梯',
          useUnit: '泉州市商场',
          unitInternalCode: 'QZ-DT-001',
          useLocation: '福建省泉州市丰泽区东海大街256号B座',
          province: '福建省',
          city: '泉州市',
          county: '丰泽区',
          useCertificateNo: 'UC20230002',
          maintenancePhone: '0595-12345678',
          rescuePhone: '0595-87654321',
          safetyManager: '陈安全',
          safetyManagerPhone: '13900139000',
          manufacturerName: '通力电梯有限公司',
          equipmentModel: 'TL-P30',
          productNumber: 'PN20230002',
          manufactureDate: '2023-01-15',
          lastInspectionDate: '2023-05-20',
          lastInspectionOrg: '福建省特种设备检验研究院泉州分院',
          floorCount: '20',
          stationCount: '20',
          doorCount: '20',
          ratedLoad: '1250kg',
          ratedSpeed: '2.5m/s',
          controlMode: '变频调速'
        }
      ],

      // 预委托表单弹窗相关
      entrustmentFormVisible: false,
      dialogTitle: '新增预委托信息',
      dialogType: 'add', // add或edit
      entrustmentForm: {
        id: undefined,
        registerDate: '',
        elevatorCode: '',
        unitName: '',
        businessContact: '',
        siteContactPerson: '',
        siteContactPhone: '',
        projectName: '',
        inspectionMonth: '',
        signCompany: '',
        creditCode: '',
        unitAddress: '',
        maintenanceUnit: '',
        status: '0'
      },
      // 表单验证规则
      rules: {
        registerDate: [{ required: true, message: '请选择登记日期', trigger: 'change' }],
        elevatorCode: [{ required: true, message: '请输入电梯识别码', trigger: 'blur' }],
        unitName: [{ required: true, message: '请选择单位名称', trigger: 'change' }],
        businessContact: [{ required: true, message: '请输入合作方业务联系人', trigger: 'blur' }],
        siteContactPerson: [{ required: true, message: '请输入现场联系人', trigger: 'blur' }],
        siteContactPhone: [
          { required: true, message: '请输入现场联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }]
      },
      // 单位选项
      unitOptions: [
        { value: '福建省建筑工程有限公司', label: '福建省建筑工程有限公司' },
        { value: '厦门市商业中心', label: '厦门市商业中心' },
        { value: '漳州市医院', label: '漳州市医院' },
        { value: '泉州市商场', label: '泉州市商场' },
        { value: '福州市学校', label: '福州市学校' }
      ],
      // 单位信息映射
      unitInfoMap: {
        福建省建筑工程有限公司: {
          businessContact: '张经理',
          siteContactPerson: '李工',
          siteContactPhone: '13812345678',
          projectName: '福建省政府办公楼',
          creditCode: '91350000XXXXXXXXXX',
          unitAddress: '福建省福州市鼓楼区省府路1号'
        },
        厦门市商业中心: {
          businessContact: '王经理',
          siteContactPerson: '赵工',
          siteContactPhone: '13987654321',
          projectName: '厦门市中心商业广场',
          creditCode: '91350200XXXXXXXXXX',
          unitAddress: '福建省厦门市思明区中山路88号'
        },
        漳州市医院: {
          businessContact: '刘主任',
          siteContactPerson: '陈工',
          siteContactPhone: '13765432109',
          projectName: '漳州市中心医院新院区',
          creditCode: '91350600XXXXXXXXXX',
          unitAddress: '福建省漳州市芗城区胜利路120号'
        },
        泉州市商场: {
          businessContact: '吴经理',
          siteContactPerson: '郑工',
          siteContactPhone: '13678901234',
          projectName: '泉州市购物中心',
          creditCode: '91350500XXXXXXXXXX',
          unitAddress: '福建省泉州市丰泽区东海大街256号'
        },
        福州市学校: {
          businessContact: '黄校长',
          siteContactPerson: '孙工',
          siteContactPhone: '13567890123',
          projectName: '福州市第一中学新校区',
          creditCode: '91350100XXXXXXXXXX',
          unitAddress: '福建省福州市台江区茶亭街道学府路18号'
        }
      },

      // 客户选择弹窗相关
      customerSelectVisible: false,
      customerLoading: false,
      customerList: [],
      customerTotal: 0,
      customerQueryParams: {
        pageNum: 1,
        pageSize: 10,
        customerName: undefined,
        usageUnit: undefined,
        projectName: undefined
      },
      selectedCustomer: null
    }
  },
  created () {
    // 模拟加载数据
    this.loading = true
    setTimeout(() => {
      this.loading = false
    }, 500)
  },
  methods: {
    /** 搜索按钮操作 */
    handleSearch () {
      // 执行搜索逻辑
      this.queryParams.pageNum = 1
      // 这里可以调用实际的搜索API
      this.$message.success('搜索功能已触发')
    },

    /** 重置按钮操作 */
    handleReset () {
      // 重置搜索条件
      this.$refs.queryForm.resetFields()
      this.dateRange = []
      this.queryParams.pageNum = 1
      // 重新加载数据
      this.$message.success('搜索条件已重置')
    },

    /** 导出按钮操作 */
    handleExport () {
      // 执行导出逻辑
      this.$message.success('正在导出预委托数据...')
      // 这里可以调用实际的导出API
    },

    /** 选中行数据 */
    handleSelectionChange (selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 点击行 */
    handleRowClick (row) {
      // 点击行时不做任何操作，仅供演示
    },

    /** 监管下载 */
    handleDownload () {
      this.equipmentLoading = true
      // 模拟加载数据
      setTimeout(() => {
        this.showEquipmentTable = true
        this.equipmentLoading = false
      }, 500)
    },

    /** 修改预委托 */
    handleUpdate (row) {
      this.$message.info(`您点击了修改按钮，预委托ID：${row.id}`)
    },

    /** 删除预委托 */
    handleDelete (row) {
      this.$message.info(`您点击了删除按钮，预委托ID：${row.id}`)
    },

    /** 打开新增预委托弹窗 */
    handleAdd () {
      this.dialogTitle = '新增预委托信息'
      this.dialogType = 'add'
      this.resetEntrustmentForm()
      // 生成一个新的电梯识别码
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const random = Math.floor(Math.random() * 1000)
        .toString()
        .padStart(3, '0')
      this.entrustmentForm.elevatorCode = `DT${year}${month}${random}`
      this.entrustmentForm.registerDate = this.formatDate(new Date())
      this.entrustmentFormVisible = true
    },

    /** 打开修改预委托弹窗 */
    handleUpdate (row) {
      this.dialogTitle = '修改预委托信息'
      this.dialogType = 'edit'
      this.resetEntrustmentForm()
      // 复制当前行数据到表单
      Object.assign(this.entrustmentForm, row)
      this.entrustmentFormVisible = true
    },

    /** 重置表单 */
    resetEntrustmentForm () {
      if (this.$refs.entrustmentForm) {
        this.$refs.entrustmentForm.resetFields()
      }
      this.entrustmentForm = {
        id: undefined,
        registerDate: '',
        elevatorCode: '',
        unitName: '',
        businessContact: '',
        siteContactPerson: '',
        siteContactPhone: '',
        projectName: '',
        inspectionMonth: '',
        signCompany: '',
        creditCode: '',
        unitAddress: '',
        maintenanceUnit: '',
        status: '0'
      }
    },

    /** 单位名称变更处理 */
    handleUnitChange (value) {
      if (value && this.unitInfoMap[value]) {
        const unitInfo = this.unitInfoMap[value]
        // 自动填充相关字段
        this.entrustmentForm.businessContact = unitInfo.businessContact
        this.entrustmentForm.siteContactPerson = unitInfo.siteContactPerson
        this.entrustmentForm.siteContactPhone = unitInfo.siteContactPhone
        this.entrustmentForm.projectName = unitInfo.projectName
        this.entrustmentForm.creditCode = unitInfo.creditCode
        this.entrustmentForm.unitAddress = unitInfo.unitAddress
      }
    },

    /** 提交预委托表单 */
    submitEntrustmentForm () {
      this.$refs.entrustmentForm.validate(valid => {
        if (valid) {
          const isAdd = this.dialogType === 'add'
          const message = isAdd ? '新增成功' : '修改成功'
          const title = isAdd ? '新增预委托信息' : '修改预委托信息'

          // 这里只是模拟，实际应该调用API
          setTimeout(() => {
            this.$message.success(`${title}：${this.entrustmentForm.elevatorCode} ${message}`)
            this.entrustmentFormVisible = false

            // 如果是新增，模拟添加到列表
            if (isAdd) {
              const newEntrustment = { ...this.entrustmentForm }
              newEntrustment.id = this.entrustmentList.length + 1
              this.entrustmentList.unshift(newEntrustment)
              this.total += 1
            } else {
              // 如果是修改，更新列表中的数据
              const index = this.entrustmentList.findIndex(
                item => item.id === this.entrustmentForm.id
              )
              if (index !== -1) {
                this.entrustmentList.splice(index, 1, { ...this.entrustmentForm })
              }
            }
          }, 300)
        }
      })
    },

    /** 格式化日期 */
    formatDate (date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    /** 打开客户选择弹窗 */
    openCustomerSelectDialog () {
      this.customerSelectVisible = true
      this.getCustomerList()
    },

    /** 获取客户列表 */
    getCustomerList () {
      this.customerLoading = true
      // 模拟加载数据
      setTimeout(() => {
        // 模拟客户数据
        this.customerList = [
          {
            id: 1,
            customerCode: 'KH20230001',
            customerName: '福建省建筑工程有限公司',
            usageUnit: '福建省政府办公楼',
            projectName: '福建省政府办公楼改造工程',
            contactPerson: '张经理',
            contactPhone: '13812345678'
          },
          {
            id: 2,
            customerCode: 'KH20230002',
            customerName: '厦门市商业中心',
            usageUnit: '厦门市中心商业广场',
            projectName: '厦门市中心商业广场改造工程',
            contactPerson: '王经理',
            contactPhone: '13987654321'
          },
          {
            id: 3,
            customerCode: 'KH20230003',
            customerName: '漳州市医院',
            usageUnit: '漳州市中心医院新院区',
            projectName: '漳州市中心医院新院区建设',
            contactPerson: '刘主任',
            contactPhone: '13765432109'
          },
          {
            id: 4,
            customerCode: 'KH20230004',
            customerName: '泉州市商场',
            usageUnit: '泉州市购物中心',
            projectName: '泉州市购物中心扩建工程',
            contactPerson: '吴经理',
            contactPhone: '13678901234'
          },
          {
            id: 5,
            customerCode: 'KH20230005',
            customerName: '福州市学校',
            usageUnit: '福州市第一中学新校区',
            projectName: '福州市第一中学新校区建设',
            contactPerson: '黄校长',
            contactPhone: '13567890123'
          }
        ]
        this.customerTotal = this.customerList.length
        this.customerLoading = false

        // 根据搜索条件过滤
        if (this.customerQueryParams.customerName) {
          this.customerList = this.customerList.filter(item =>
            item.customerName.includes(this.customerQueryParams.customerName)
          )
        }
        if (this.customerQueryParams.usageUnit) {
          this.customerList = this.customerList.filter(item =>
            item.usageUnit.includes(this.customerQueryParams.usageUnit)
          )
        }
        if (this.customerQueryParams.projectName) {
          this.customerList = this.customerList.filter(item =>
            item.projectName.includes(this.customerQueryParams.projectName)
          )
        }
      }, 500)
    },

    /** 搜索客户 */
    searchCustomers () {
      this.customerQueryParams.pageNum = 1
      this.getCustomerList()
    },

    /** 重置客户搜索条件 */
    resetCustomerQuery () {
      this.$refs.customerQueryForm.resetFields()
      this.customerQueryParams.pageNum = 1
      this.getCustomerList()
    },

    /** 客户行点击 */
    handleCustomerRowClick (row) {
      this.selectedCustomer = row
    },

    /** 客户多选 */
    handleCustomerSelectionChange (selection) {
      this.selectedCustomer = selection.length === 1 ? selection[0] : null
    },

    /** 确认选择客户 */
    confirmSelectCustomer () {
      if (this.selectedCustomer) {
        this.entrustmentForm.unitName = this.selectedCustomer.customerName
        this.entrustmentForm.businessContact = this.selectedCustomer.contactPerson
        this.entrustmentForm.siteContactPerson = this.selectedCustomer.contactPerson
        this.entrustmentForm.siteContactPhone = this.selectedCustomer.contactPhone
        this.entrustmentForm.projectName = this.selectedCustomer.projectName
        this.entrustmentForm.creditCode = this.selectedCustomer.customerCode // 假设客户编号就是信用代码
        this.entrustmentForm.unitAddress = this.selectedCustomer.usageUnit
        this.customerSelectVisible = false
      } else {
        this.$message.warning('请选择一个客户')
      }
    }
  }
}
</script>

<style scoped>
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.mb8 {
  margin-bottom: 8px;
}
.equipment-table-container {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
}
.equipment-table-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}
.equipment-table-title span {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.input-with-search {
  display: flex;
  align-items: center;
}
.input-with-search .el-input {
  flex: 1;
}
.search-button {
  margin-left: 5px;
  padding: 7px;
  border-radius: 4px;
}
.customer-pagination {
  margin-top: 10px;
}
::v-deep .el-table__body-wrapper {
  z-index: 2;
}
</style>
